import { useId } from "react";

import { cn } from "@/lib/utils";

export function CouponsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-7.5 w-[53px]", className)}
      fill="none"
      viewBox="0 0 53 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.82 30h11.352V0H3.82a3.906 3.906 0 00-2.7 1.072A3.586 3.586 0 000 3.66v4.16c-.001.56.406 1.045.977 1.163a6.503 6.503 0 013.63 2.158A6.03 6.03 0 016.038 15a6.018 6.018 0 01-1.426 3.861 6.49 6.49 0 01-3.634 2.157c-.57.12-.977.603-.977 1.163v4.161c0 .97.403 1.901 1.12 2.587A3.905 3.905 0 003.82 30zm13.828 0h30.55a3.907 3.907 0 002.699-1.073 3.586 3.586 0 001.119-2.587V3.66c0-.97-.403-1.901-1.12-2.587A3.907 3.907 0 0048.198.001h-30.55V30z"
        fill="#000"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3.82 30h11.352V0H3.82a3.906 3.906 0 00-2.7 1.072A3.586 3.586 0 000 3.66v4.16c-.001.56.406 1.045.977 1.163a6.503 6.503 0 013.63 2.158A6.03 6.03 0 016.038 15a6.018 6.018 0 01-1.426 3.861 6.49 6.49 0 01-3.634 2.157c-.57.12-.977.603-.977 1.163v4.161c0 .97.403 1.901 1.12 2.587A3.905 3.905 0 003.82 30zm13.828 0h30.55a3.907 3.907 0 002.699-1.073 3.586 3.586 0 001.119-2.587V3.66c0-.97-.403-1.901-1.12-2.587A3.907 3.907 0 0048.198.001h-30.55V30z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <path
        d="M35.88 18.917c0-.566.108-1.088.324-1.567.231-.493.54-.92.926-1.284a4.304 4.304 0 011.365-.87 4.364 4.364 0 011.689-.326c.601 0 1.156.109 1.665.326.525.203.98.493 1.365.87.401.363.71.791.926 1.284.231.479.347 1.001.347 1.567 0 .566-.116 1.095-.347 1.588a4.023 4.023 0 01-.926 1.284 4.47 4.47 0 01-1.365.87 4.454 4.454 0 01-1.665.305 4.636 4.636 0 01-1.69-.305 4.873 4.873 0 01-1.364-.87 4.56 4.56 0 01-.926-1.284 3.917 3.917 0 01-.324-1.588zm6.386 0c0-.551-.2-1.016-.602-1.393-.4-.377-.894-.565-1.48-.565-.587 0-1.08.188-1.481.565a1.836 1.836 0 00-.602 1.393c0 .551.2 1.015.602 1.392.4.377.894.566 1.48.566.587 0 1.08-.189 1.481-.566.401-.377.602-.841.602-1.392zM24.89 11.084c0-.566.108-1.088.324-1.566.23-.494.54-.922.925-1.284a4.303 4.303 0 011.365-.87 4.363 4.363 0 011.689-.327c.602 0 1.157.109 1.666.327.524.203.98.493 1.365.87.4.362.71.79.925 1.284.232.478.347 1 .347 1.566a3.68 3.68 0 01-.347 1.588 4.024 4.024 0 01-.925 1.284 4.45 4.45 0 01-1.365.87 4.456 4.456 0 01-1.666.305 4.638 4.638 0 01-1.689-.305 4.878 4.878 0 01-1.365-.87 4.562 4.562 0 01-.925-1.284 3.917 3.917 0 01-.324-1.588zm6.385 0c0-.551-.2-1.015-.601-1.392-.401-.378-.895-.566-1.481-.566-.586 0-1.08.188-1.48.566a1.836 1.836 0 00-.602 1.392c0 .551.2 1.015.601 1.393.401.377.895.565 1.48.565.587 0 1.08-.188 1.482-.565.4-.378.601-.842.601-1.393zm7.288-4.482l1.92.827-9.624 15.97-1.92-.827 9.624-15.97z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="4.625"
          x2="42.237"
          y1="28.274"
          y2="5.858"
        >
          <stop stopColor="#6315ea" />
          <stop offset="1" stopColor="#ef67b0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function LikeIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M5.114 8.847v7.868a.793.793 0 01-.788.785H.788A.79.79 0 010 16.715V8.847c0-.431.357-.788.788-.788h3.538c.432 0 .788.357.788.788z"
        fill={`url(#${id}-a)`}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.308 6.485h-3.404c.282-1.133 1.043-1.564 1.043-3.146 0-2.887-3.288-5.349-4.118-.91-.247 1.196-2.967 5.522-4.177 5.617-.408.039-.75.381-.75.788v7.88c0 .431.369.773.785.785.431.015 1.169.27 1.942.541 1.33.455 2.988 1.035 4.746 1.035 2.28 0 4.861.424 4.606-2.796 1.198-.4 2.128-2.214 1.198-3.597 1.2-1.198.985-2.39 0-3.596 0 0 .8-1.998-1.87-2.6z"
        fill={`url(#${id}-b)`}
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="18.188"
          x2="5.262"
          y1="3.273"
          y2="11.348"
        >
          <stop stopColor="#fa7e4a" />
          <stop offset="1" stopColor="#ffc850" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="18.188"
          x2="5.262"
          y1="3.273"
          y2="11.348"
        >
          <stop stopColor="#fa7e4a" />
          <stop offset="1" stopColor="#ffc850" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function PlayedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5 text-bright-turquoise", className)}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M0 8.768C0 3.928 3.928 0 8.768 0c4.84 0 8.768 3.928 8.768 8.768 0 4.84-3.928 8.768-8.768 8.768C3.928 17.536 0 13.608 0 8.768zm3.244.614l3.148 3.148a.873.873 0 001.236 0l6.655-6.655a.873.873 0 10-1.236-1.237l-6.033 6.033-2.533-2.525a.873.873 0 10-1.237 1.236z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function PlusIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[15px] text-white", className)}
      fill="none"
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1.5v12m-6-6h12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}
